import React from "react";
import { Card } from '@material-ui/core';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import SchemaStars from "./schemastars";
import QuoteRequestModalLibrary from "./quote-request-modal-library";

const ProCardsNearMe = (props) => {

    const pro = props.proData;
    const formattedPhone = pro.ph && formatePhone(pro.ph)
    const description = fixDescription(pro.d)
    const uuidv4 = require("uuid/v4")
    const randomId = pro._attributes_id + "-" + uuidv4();

    function fixDescription(description){
        let desc = stripHtml(description);
        if(desc.length > 250){
            desc = desc.substring(0,250);
            desc += "... ";
        }
        return desc
    }

    function stripHtml(html) {
        let aux = html.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/g, ' ');
        return aux.replaceAll("&amp;", "&");
    }

    function formatePhone(phone) {
        let newPhone = "(" + phone[0] + phone[1] + phone[2] + ") " + phone[3] + phone[4] + phone[5] + "-" + phone[6] + phone[7] + phone[8] + phone[9];
        return newPhone;
    }

    return (
        <><Card className="nearMeCard" data-proid={pro._attributes_id} itemscope="itemscope" itemtype="https://schema.org/LocalBusiness" id={randomId}>
            <CardContent>
                <div data-id={pro._attributes_id} className="proCardNearMe">
                    <div className="title row">
                        <a href={"/"+pro.ur} itemprop="url"><span itemprop="name">{pro.n}</span></a>
                    </div>
                    {pro.r > 0 && <div className="reviews row">
                        <SchemaStars calculated={pro.rt && parseFloat(pro.rt).toFixed(1).toString()} url={"/"+pro.ur} reviews={pro.r}/>
                    </div>}
                    <div className="text">
                        <p itemprop="description">{description}{description.length == 254 && <a href={"/"+pro.ur}>more</a>}</p>
                    </div>
                    <div className="cardFooter row">
                        { pro.ph && 
                        <>
                        <div className="col-lg-7 row">
                            <Button variant="text" className="phoneButton" data-proid={pro._attributes_id} >
                                <a className="phoneText pro-phone-cont" href={'tel://' + pro.ph}><span>Call now: <span itemprop="telephone"> {formattedPhone}</span></span></a>
                            </Button>
                        </div>
                        |</>}
                        <div className="col-lg-5 row">
                            <div className="getAQuoteButtonContainer">
                                <QuoteRequestModalLibrary
                                    showButton={true}
                                    startVisible={false}
                                    proid={pro._attributes_id}
                                    ondeffCode={props.code === 'demolition' ? 'demolitionQuoteRequest' : props.code === 'junk-removal' ? 'junkRemovalQuoteRequest' : 'dumpsterQuoteRequest'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
        </>
    )
}

export default ProCardsNearMe;